// import React, { useState, useEffect } from 'react';

// const Aboutus = () => {
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth <= 768);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     return (
//         <div
//             style={{
//                 height: "100%",
//                 width: "100%",
//                 flexDirection: isMobile ? "column" : "row",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 padding: isMobile ? "20px" : "0"
//             }}
//         >
//             {/* Left Text Section */}
//             <div
//                 style={{
//                     height: "auto",
//                     width: isMobile ? "100%" : "50%",
//                     justifyContent: "center",
//                     padding: "2%",
//                     textAlign: isMobile ? "center" : "left"
//                 }}
//             >
//                 <h1
//                     style={{
//                         fontSize: isMobile ? 24 : 30,
//                         textAlign: "center",
//                         textDecoration: "underline",
//                         textDecorationColor: '#ff6500',
//                         color: '#121e4b',
//                         textDecorationThickness: "2px",
//                         textUnderlineOffset: "10px",
//                         letterSpacing: "5px",
//                     }}
//                 >
//                     ABOUT
//                 </h1>

//                 <h2 style={{ color: "#ff6500", fontSize: isMobile ? 18 : 22 }}>
//                 StructGuard – Leading Manufacturer & Exporter of High-Strength Precast Concrete Products
//                 </h2>

//                 <p
//                     style={{
//                         fontSize: isMobile ? "14px" : "16px",
//                         lineHeight: "1.6",
//                         color: '#333',
//                         textAlign: "justify",
//                         margin: "16px 0"
//                     }}
//                 >
//                     StructGuard is a manufacturer of high-strength concrete precast products which are widely used in the construction industry.
//                     Our manufacturing facility is spread over 30,000 sq ft and equipped with the latest and advanced technology in the industry which helps us to accelerate our production capacity. To make operations smoother, faster, and flawless, we have divided our systems into departments i.e. Purchase, tendering, accounts, admin, manufacturing, quality control, warehousing and storage, and transportation, to meet the industrial requirements. We supply Precast Products across India and make sure that our customers are happy and satisfied with our quality and on time delivery.<br /><br />
//                     We carry out the entire production process to meet the highest benchmark of quality. The raw material used in the manufacturing process is sourced from reliable vendors of an industry by checking the same thoroughly. We have a tie-up with some of the most advanced testing labs where we conduct the concrete cube and other required tests periodically to maintain a uniform quality product in every batch.
//                 </p>
//             </div>

//             {/* Right Image Section */}
//             <div
//                 style={{
//                     height: "auto",
//                     width: isMobile ? "100%" : "50%",
//                     display: "flex",
//                     justifyContent: "center",
//                     padding: "2%",
//                     alignItems: "center",
//                 }}
//             >
//                 <img
//                     src={require('../Images/companyimg.webp')}
//                     alt="Example"
//                     style={{
//                         maxWidth: "100%",
//                         maxHeight: "100%",
//                         objectFit: "contain",
//                         borderRadius: 12,
//                         background: "green"
//                     }}
//                 />
//             </div>
//         </div>
//     );
// };

// export default Aboutus;



import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import companyImage from '../Images/factoryimg.webp';

const Aboutus = () => {

    const [isMobile, setIsMobile] = useState(
        window.innerWidth <= 768
    );

    const [activeProcess, setActiveProcess] = useState(0);

    /* =========================================
       RESPONSIVE
    ========================================= */

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener(
            'resize',
            handleResize
        );

        return () => {
            window.removeEventListener(
                'resize',
                handleResize
            );
        };

    }, []);


    /* =========================================
       AUTO PROCESS ANIMATION
    ========================================= */

    useEffect(() => {

        const interval = setInterval(() => {

            setActiveProcess((prev) =>
                (prev + 1) % processSteps.length
            );

        }, 3500);

        return () => clearInterval(interval);

    }, []);


    /* =========================================
       PROCESS DATA
    ========================================= */

    const processSteps = [
        {
            number: '01',
            title: 'Raw Material',
            description:
                'Quality raw materials are sourced from reliable vendors and thoroughly checked before entering production.',
            icon: '◆',
        },

        {
            number: '02',
            title: 'Manufacturing',
            description:
                'Controlled manufacturing processes help maintain consistency, dimensional accuracy and dependable product performance.',
            icon: '▣',
        },

        {
            number: '03',
            title: 'Quality Control',
            description:
                'Products are monitored through quality checks and periodic concrete testing to maintain batch-to-batch consistency.',
            icon: '✓',
        },

        {
            number: '04',
            title: 'Warehousing',
            description:
                'Finished products are organized and stored systematically for efficient handling and dispatch.',
            icon: '▤',
        },

        {
            number: '05',
            title: 'Delivery',
            description:
                'Products are coordinated for timely transportation and supply to customers across India.',
            icon: '→',
        },
    ];


    /* =========================================
       WHY STRUCTGUARD
    ========================================= */

    const strengths = [
        {
            number: '01',
            title: 'High-Strength Products',
            text:
                'Manufactured concrete products designed for dependable construction applications.',
            icon: '◈',
        },

        {
            number: '02',
            title: 'Quality Control',
            text:
                'Systematic quality checks and testing help maintain consistent product standards.',
            icon: '✓',
        },

        {
            number: '03',
            title: '30,000 Sq. Ft. Facility',
            text:
                'A dedicated manufacturing facility supporting organized production and operations.',
            icon: '▦',
        },

        {
            number: '04',
            title: 'Pan-India Supply',
            text:
                'Structured warehousing, transportation and dispatch operations support customers across India.',
            icon: '⌁',
        },
    ];


    return (

        <section
            id="about"
            style={styles.section}
        >

            {/* =====================================
                BACKGROUND DECORATION
            ====================================== */}

            <div style={styles.backgroundCircleOne} />

            <div style={styles.backgroundCircleTwo} />

            <div style={styles.backgroundGrid} />


            {/* =====================================
                SECTION HEADER
            ====================================== */}

            <motion.div
                initial={{
                    opacity: 0,
                    y: 40,
                }}
                whileInView={{
                    opacity: 1,
                    y: 0,
                }}
                viewport={{
                    once: true,
                    amount: 0.2,
                }}
                transition={{
                    duration: 0.7,
                }}
                style={styles.sectionHeader}
            >

                <div style={styles.eyebrow}>

                    <span style={styles.eyebrowLine} />

                    ABOUT STRUCTGUARD

                    <span style={styles.eyebrowLine} />

                </div>


                <h1 style={styles.mainHeading}>

                    Building Quality.
                    <span style={styles.orangeText}>
                        {' '}Delivering Confidence.
                    </span>

                </h1>


                <p style={styles.headerDescription}>

                    A manufacturing-driven approach to high-strength
                    precast concrete products, quality control and
                    dependable supply.

                </p>

            </motion.div>


            {/* =====================================
                MAIN ABOUT AREA
            ====================================== */}

            <div
                style={{
                    ...styles.mainGrid,
                    ...(isMobile
                        ? styles.mainGridMobile
                        : {}),
                }}
            >

                {/* =================================
                    LEFT IMAGE
                ================================= */}

                <motion.div
                    initial={{
                        opacity: 0,
                        x: -60,
                    }}
                    whileInView={{
                        opacity: 1,
                        x: 0,
                    }}
                    viewport={{
                        once: true,
                        amount: 0.2,
                    }}
                    transition={{
                        duration: 0.8,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                    style={styles.imageArea}
                >

                    <div style={styles.imageFrame}>

                        {/* Image */}

                        <motion.img
                            src={companyImage}
                            alt="StructGuard manufacturing facility"
                            style={styles.companyImage}
                            whileHover={{
                                scale: 1.04,
                            }}
                            transition={{
                                duration: 0.6,
                            }}
                        />


                        {/* Image overlay */}

                        <div style={styles.imageOverlay} />


                        {/* Facility badge */}

                        <motion.div
                            initial={{
                                opacity: 0,
                                y: 20,
                            }}
                            whileInView={{
                                opacity: 1,
                                y: 0,
                            }}
                            viewport={{
                                once: true,
                            }}
                            transition={{
                                delay: 0.5,
                                duration: 0.5,
                            }}
                            style={styles.facilityBadge}
                        >

                            <div style={styles.facilityNumber}>
                                30,000
                            </div>

                            <div style={styles.facilityUnit}>
                                SQ. FT. FACILITY
                            </div>

                        </motion.div>


                        {/* Floating quality badge */}

                        <motion.div
                            animate={{
                                y: [0, -8, 0],
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: 'easeInOut',
                            }}
                            style={styles.qualityBadge}
                        >

                            <div style={styles.qualityIcon}>
                                ✓
                            </div>

                            <div>

                                <div style={styles.qualityTitle}>
                                    Quality Driven
                                </div>

                                <div style={styles.qualitySub}>
                                    Every batch matters
                                </div>

                            </div>

                        </motion.div>

                    </div>

                </motion.div>


                {/* =================================
                    RIGHT TEXT
                ================================= */}

                <motion.div
                    initial={{
                        opacity: 0,
                        x: 60,
                    }}
                    whileInView={{
                        opacity: 1,
                        x: 0,
                    }}
                    viewport={{
                        once: true,
                        amount: 0.2,
                    }}
                    transition={{
                        duration: 0.8,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                    style={styles.textArea}
                >

                    <div style={styles.textLabel}>
                        WHO WE ARE
                    </div>


                    <h2 style={styles.aboutHeading}>

                        StructGuard —
                        <span style={styles.orangeText}>
                            {' '}Built Around Quality.
                        </span>

                    </h2>


                    <p style={styles.aboutParagraph}>

                        StructGuard Infra Products & Services LLP
                        is a manufacturer of high-strength precast
                        concrete products widely used across the
                        construction industry.

                    </p>


                    <p style={styles.aboutParagraph}>

                        Our manufacturing facility is spread across
                        30,000 sq. ft. and is supported by organized
                        systems covering procurement, tendering,
                        accounts, administration, manufacturing,
                        quality control, warehousing, storage and
                        transportation.

                    </p>


                    <p style={styles.aboutParagraph}>

                        We focus on maintaining consistent product
                        quality by sourcing raw materials from
                        reliable vendors, implementing controlled
                        production processes and carrying out
                        periodic testing through advanced testing
                        laboratories.

                    </p>


                    {/* Highlight points */}

                    <div style={styles.highlightGrid}>

                        <Highlight
                            icon="✓"
                            title="Quality"
                            text="Consistent production standards"
                        />

                        <Highlight
                            icon="◆"
                            title="Precision"
                            text="Controlled manufacturing"
                        />

                        <Highlight
                            icon="→"
                            title="Supply"
                            text="Pan-India delivery"
                        />

                    </div>

                </motion.div>

            </div>


            {/* =====================================
                WHY STRUCTGUARD
            ====================================== */}

            <motion.div
                initial={{
                    opacity: 0,
                    y: 35,
                }}
                whileInView={{
                    opacity: 1,
                    y: 0,
                }}
                viewport={{
                    once: true,
                    amount: 0.2,
                }}
                transition={{
                    duration: 0.7,
                }}
                style={styles.whyHeader}
            >

                <div style={styles.textLabel}>
                    WHY STRUCTGUARD
                </div>

                <h2 style={styles.whyHeading}>

                    More Than Products.
                    <span style={styles.orangeText}>
                        {' '}A Reliable Process.
                    </span>

                </h2>

            </motion.div>


            <div
                style={{
                    ...styles.strengthGrid,
                    ...(isMobile
                        ? styles.strengthGridMobile
                        : {}),
                }}
            >

                {strengths.map((item, index) => (

                    <motion.div
                        key={item.number}
                        initial={{
                            opacity: 0,
                            y: 35,
                        }}
                        whileInView={{
                            opacity: 1,
                            y: 0,
                        }}
                        viewport={{
                            once: true,
                            amount: 0.15,
                        }}
                        transition={{
                            delay: index * 0.08,
                            duration: 0.55,
                        }}
                        whileHover={{
                            y: -7,
                        }}
                        style={styles.strengthCard}
                    >

                        <div style={styles.strengthTop}>

                            <div style={styles.strengthIcon}>
                                {item.icon}
                            </div>

                            <div style={styles.strengthNumber}>
                                {item.number}
                            </div>

                        </div>


                        <h3 style={styles.strengthTitle}>
                            {item.title}
                        </h3>


                        <p style={styles.strengthText}>
                            {item.text}
                        </p>


                        <div style={styles.cardBottomLine} />

                    </motion.div>

                ))}

            </div>


            {/* =====================================
                MANUFACTURING PROCESS
            ====================================== */}

            <motion.div
                initial={{
                    opacity: 0,
                    y: 35,
                }}
                whileInView={{
                    opacity: 1,
                    y: 0,
                }}
                viewport={{
                    once: true,
                    amount: 0.15,
                }}
                transition={{
                    duration: 0.7,
                }}
                style={styles.processHeader}
            >

                <div style={styles.textLabel}>
                    OUR APPROACH
                </div>

                <h2 style={styles.processHeading}>

                    From Raw Material
                    <span style={styles.orangeText}>
                        {' '}to Delivery.
                    </span>

                </h2>

                <p style={styles.processDescription}>

                    A structured process designed to keep
                    quality, consistency and delivery at the
                    center of every order.

                </p>

            </motion.div>


            {/* =====================================
                PROCESS TIMELINE
            ====================================== */}

            <div
                style={{
                    ...styles.processContainer,
                    ...(isMobile
                        ? styles.processContainerMobile
                        : {}),
                }}
            >

                {/* Timeline line */}

                {!isMobile && (
                    <div style={styles.timelineLine} />
                )}


                {processSteps.map((step, index) => {

                    const isActive =
                        activeProcess === index;

                    return (

                        <motion.div
                            key={step.number}
                            onClick={() =>
                                setActiveProcess(index)
                            }
                            whileHover={{
                                y: -5,
                            }}
                            style={{
                                ...styles.processItem,
                                ...(isActive
                                    ? styles.processItemActive
                                    : {}),
                            }}
                        >

                            <motion.div
                                animate={{
                                    scale:
                                        isActive
                                            ? 1.12
                                            : 1,
                                }}
                                style={{
                                    ...styles.processCircle,
                                    ...(isActive
                                        ? styles.processCircleActive
                                        : {}),
                                }}
                            >

                                {step.icon}

                            </motion.div>


                            <div style={styles.processNumber}>
                                {step.number}
                            </div>


                            <h3 style={styles.processTitle}>
                                {step.title}
                            </h3>


                            <motion.p
                                animate={{
                                    opacity:
                                        isActive
                                            ? 1
                                            : isMobile
                                                ? 0.7
                                                : 0.55,
                                }}
                                style={styles.processText}
                            >
                                {step.description}
                            </motion.p>

                        </motion.div>

                    );

                })}

            </div>


            {/* =====================================
                FINAL CTA
            ====================================== */}

            <motion.div
                initial={{
                    opacity: 0,
                    scale: 0.96,
                }}
                whileInView={{
                    opacity: 1,
                    scale: 1,
                }}
                viewport={{
                    once: true,
                    amount: 0.2,
                }}
                transition={{
                    duration: 0.7,
                }}
                style={{
                    ...styles.cta,
                    ...(isMobile
                        ? styles.ctaMobile
                        : {}),
                }}
            >

                <div style={styles.ctaGlow} />

                <div style={styles.ctaContent}>

                    <div style={styles.ctaLabel}>
                        BUILT FOR YOUR NEXT PROJECT
                    </div>

                    <h2 style={styles.ctaHeading}>
                        Looking for reliable
                        <span>
                            {' '}precast products?
                        </span>
                    </h2>

                    <p style={styles.ctaText}>

                        Explore our product range or connect
                        with our team to discuss your
                        construction requirements.

                    </p>

                </div>


                <motion.button
                    whileHover={{
                        scale: 1.05,
                        x: 3,
                    }}
                    whileTap={{
                        scale: 0.96,
                    }}
                    style={styles.ctaButton}
                    onClick={() => {

                        const section =
                            document.getElementById(
                                'product'
                            );

                        if (section) {
                            section.scrollIntoView({
                                behavior: 'smooth',
                            });
                        }

                    }}
                >

                    Explore Products

                    <span style={styles.ctaArrow}>
                        →
                    </span>

                </motion.button>

            </motion.div>

        </section>

    );
};


/* =========================================
   HIGHLIGHT COMPONENT
========================================= */

const Highlight = ({
    icon,
    title,
    text,
}) => {

    return (

        <motion.div
            whileHover={{
                y: -4,
            }}
            style={styles.highlight}
        >

            <div style={styles.highlightIcon}>
                {icon}
            </div>

            <div>

                <div style={styles.highlightTitle}>
                    {title}
                </div>

                <div style={styles.highlightText}>
                    {text}
                </div>

            </div>

        </motion.div>

    );
};


/* =========================================
   INLINE STYLES
========================================= */

const styles = {

    /* =====================================
       SECTION
    ====================================== */

    section: {
        position: 'relative',

        width: '100%',

        minHeight: '100vh',

        padding:
            '100px 6% 90px 6%',

        boxSizing: 'border-box',

        overflow: 'hidden',

        background:
            'linear-gradient(180deg, #ffffff 0%, #f8fafb 100%)',

        fontFamily:
            'Inter, Arial, Helvetica, sans-serif',

        color: '#17232b',
    },


    /* =====================================
       BACKGROUND
    ====================================== */

    backgroundCircleOne: {
        position: 'absolute',

        width: '520px',
        height: '520px',

        borderRadius: '50%',

        background:
            'rgba(242,107,33,0.035)',

        top: '-260px',
        right: '-200px',

        pointerEvents: 'none',
    },


    backgroundCircleTwo: {
        position: 'absolute',

        width: '400px',
        height: '400px',

        borderRadius: '50%',

        border:
            '1px solid rgba(242,107,33,0.07)',

        bottom: '-220px',
        left: '-200px',

        pointerEvents: 'none',
    },


    backgroundGrid: {
        position: 'absolute',

        top: 0,
        left: 0,

        width: '100%',
        height: '100%',

        opacity: 0.18,

        pointerEvents: 'none',

        backgroundImage:
            'linear-gradient(rgba(20,35,45,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(20,35,45,0.035) 1px, transparent 1px)',

        backgroundSize: '70px 70px',
    },


    /* =====================================
       HEADER
    ====================================== */

    sectionHeader: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '800px',

        margin:
            '0 auto 70px auto',

        textAlign: 'center',
    },


    eyebrow: {
        display: 'flex',

        alignItems: 'center',

        justifyContent: 'center',

        gap: '12px',

        marginBottom: '17px',

        color: '#f26b21',

        fontSize: '10px',

        fontWeight: '800',

        letterSpacing: '2.5px',
    },


    eyebrowLine: {
        width: '35px',

        height: '2px',

        background: '#f26b21',

        borderRadius: '10px',
    },


    mainHeading: {
        margin: 0,

        fontSize:
            'clamp(38px, 5vw, 60px)',

        lineHeight: '1.08',

        letterSpacing: '-2.5px',

        fontWeight: '800',

        color: '#17232b',
    },


    orangeText: {
        color: '#f26b21',
    },


    headerDescription: {
        maxWidth: '650px',

        margin:
            '20px auto 0 auto',

        color: '#707b82',

        fontSize: '15px',

        lineHeight: '1.7',
    },


    /* =====================================
       MAIN GRID
    ====================================== */

    mainGrid: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '1250px',

        margin:
            '0 auto 100px auto',

        display: 'grid',

        gridTemplateColumns:
            '1fr 1fr',

        gap: '70px',

        alignItems: 'center',
    },


    mainGridMobile: {
        gridTemplateColumns: '1fr',

        gap: '45px',
    },


    /* =====================================
       IMAGE
    ====================================== */

    imageArea: {
        width: '100%',
    },


    imageFrame: {
        position: 'relative',

        width: '100%',

        height: '500px',

        borderRadius: '24px',

        overflow: 'hidden',

        background: '#edf1f3',

        boxShadow:
            '0 25px 60px rgba(25,35,42,0.12)',
    },


    companyImage: {
        width: '100%',
        height: '100%',

        objectFit: 'cover',

        display: 'block',
    },


    imageOverlay: {
        position: 'absolute',

        inset: 0,

        background:
            'linear-gradient(180deg, rgba(10,20,25,0.02) 40%, rgba(10,20,25,0.62) 100%)',

        pointerEvents: 'none',
    },


    /* =====================================
       FACILITY BADGE
    ====================================== */

    facilityBadge: {
        position: 'absolute',

        bottom: '25px',
        left: '25px',

        padding:
            '15px 20px',

        borderRadius: '14px',

        background:
            'rgba(255,255,255,0.94)',

        backdropFilter: 'blur(12px)',

        boxShadow:
            '0 12px 30px rgba(0,0,0,0.14)',
    },


    facilityNumber: {
        color: '#17232b',

        fontSize: '28px',

        lineHeight: 1,

        fontWeight: '800',
    },


    facilityUnit: {
        marginTop: '5px',

        color: '#f26b21',

        fontSize: '8px',

        fontWeight: '800',

        letterSpacing: '1.4px',
    },


    /* =====================================
       QUALITY BADGE
    ====================================== */

    qualityBadge: {
        position: 'absolute',

        top: '25px',
        right: '25px',

        display: 'flex',

        alignItems: 'center',

        gap: '10px',

        padding:
            '10px 14px',

        borderRadius: '12px',

        background:
            'rgba(255,255,255,0.94)',

        backdropFilter: 'blur(10px)',

        boxShadow:
            '0 10px 30px rgba(0,0,0,0.12)',
    },


    qualityIcon: {
        width: '31px',
        height: '31px',

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '50%',

        background: '#fff0e7',

        color: '#f26b21',

        fontWeight: '800',
    },


    qualityTitle: {
        color: '#26333b',

        fontSize: '11px',

        fontWeight: '800',
    },


    qualitySub: {
        color: '#8a949a',

        fontSize: '8px',

        marginTop: '2px',
    },


    /* =====================================
       TEXT
    ====================================== */

    textArea: {
        width: '100%',
    },


    textLabel: {
        color: '#f26b21',

        fontSize: '9px',

        fontWeight: '800',

        letterSpacing: '2px',

        marginBottom: '12px',
    },


    aboutHeading: {
        margin:
            '0 0 20px 0',

        color: '#17232b',

        fontSize:
            'clamp(30px, 4vw, 43px)',

        lineHeight: '1.12',

        letterSpacing: '-1.5px',

        fontWeight: '800',
    },


    aboutParagraph: {
        margin:
            '0 0 16px 0',

        color: '#69747b',

        fontSize: '14px',

        lineHeight: '1.8',
    },


    /* =====================================
       HIGHLIGHTS
    ====================================== */

    highlightGrid: {
        marginTop: '28px',

        display: 'grid',

        gridTemplateColumns:
            'repeat(3, 1fr)',

        gap: '10px',
    },


    highlight: {
        padding:
            '12px 10px',

        border:
            '1px solid #e8edef',

        borderRadius: '12px',

        background: '#ffffff',

        display: 'flex',

        alignItems: 'center',

        gap: '9px',

        boxShadow:
            '0 5px 20px rgba(20,30,40,0.03)',
    },


    highlightIcon: {
        width: '28px',
        height: '28px',

        flexShrink: 0,

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '8px',

        background: '#fff2ea',

        color: '#f26b21',

        fontSize: '11px',

        fontWeight: '800',
    },


    highlightTitle: {
        color: '#27343c',

        fontSize: '9px',

        fontWeight: '800',
    },


    highlightText: {
        marginTop: '2px',

        color: '#89939a',

        fontSize: '7px',

        lineHeight: '1.3',
    },


    /* =====================================
       WHY SECTION
    ====================================== */

    whyHeader: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '1250px',

        margin:
            '0 auto 35px auto',
    },


    whyHeading: {
        margin: 0,

        color: '#17232b',

        fontSize:
            'clamp(28px, 4vw, 42px)',

        lineHeight: '1.15',

        letterSpacing: '-1.5px',

        fontWeight: '800',
    },


    /* =====================================
       STRENGTH CARDS
    ====================================== */

    strengthGrid: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '1250px',

        margin:
            '0 auto 110px auto',

        display: 'grid',

        gridTemplateColumns:
            'repeat(4, 1fr)',

        gap: '18px',
    },


    strengthGridMobile: {
        gridTemplateColumns:
            '1fr',

        maxWidth: '500px',
    },


    strengthCard: {
        position: 'relative',

        minHeight: '205px',

        padding: '23px',

        boxSizing: 'border-box',

        border:
            '1px solid #e6ebed',

        borderRadius: '17px',

        background: '#ffffff',

        boxShadow:
            '0 8px 28px rgba(20,30,40,0.045)',

        overflow: 'hidden',

        transition:
            'box-shadow 0.3s ease',
    },


    strengthTop: {
        display: 'flex',

        alignItems: 'center',

        justifyContent: 'space-between',
    },


    strengthIcon: {
        width: '38px',
        height: '38px',

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '10px',

        background: '#fff2ea',

        color: '#f26b21',

        fontSize: '14px',

        fontWeight: '800',
    },


    strengthNumber: {
        color: '#e6eaec',

        fontSize: '22px',

        fontWeight: '800',
    },


    strengthTitle: {
        margin:
            '25px 0 8px 0',

        color: '#26333b',

        fontSize: '15px',

        fontWeight: '800',
    },


    strengthText: {
        margin: 0,

        color: '#7d888f',

        fontSize: '11px',

        lineHeight: '1.65',
    },


    cardBottomLine: {
        position: 'absolute',

        bottom: 0,
        left: 0,

        width: '100%',
        height: '3px',

        background:
            'linear-gradient(90deg, #f26b21, #ff9a66)',
    },


    /* =====================================
       PROCESS HEADER
    ====================================== */

    processHeader: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '1250px',

        margin:
            '0 auto 50px auto',
    },


    processHeading: {
        margin: 0,

        color: '#17232b',

        fontSize:
            'clamp(30px, 4vw, 45px)',

        lineHeight: '1.12',

        letterSpacing: '-1.5px',

        fontWeight: '800',
    },


    processDescription: {
        maxWidth: '550px',

        margin:
            '15px 0 0 0',

        color: '#7b858c',

        fontSize: '13px',

        lineHeight: '1.7',
    },


    /* =====================================
       PROCESS
    ====================================== */

    processContainer: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '1250px',

        margin:
            '0 auto 100px auto',

        display: 'grid',

        gridTemplateColumns:
            'repeat(5, 1fr)',

        gap: '18px',
    },


    processContainerMobile: {
        gridTemplateColumns:
            '1fr',

        gap: '13px',

        maxWidth: '500px',
    },


    timelineLine: {
        position: 'absolute',

        top: '30px',
        left: '10%',

        width: '80%',
        height: '1px',

        background:
            '#dfe5e8',

        zIndex: -1,
    },


    processItem: {
        position: 'relative',

        padding:
            '10px 12px 15px 12px',

        borderRadius: '15px',

        cursor: 'pointer',

        transition:
            'background 0.3s ease',
    },


    processItemActive: {
        background: '#ffffff',

        boxShadow:
            '0 8px 25px rgba(20,30,40,0.05)',
    },


    processCircle: {
        width: '58px',
        height: '58px',

        margin:
            '0 auto 12px auto',

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '50%',

        background: '#ffffff',

        border:
            '1px solid #e0e6e9',

        color: '#8c969c',

        fontSize: '15px',

        fontWeight: '800',

        boxShadow:
            '0 5px 15px rgba(20,30,40,0.04)',
    },


    processCircleActive: {
        background: '#f26b21',

        borderColor: '#f26b21',

        color: '#ffffff',

        boxShadow:
            '0 8px 25px rgba(242,107,33,0.28)',
    },


    processNumber: {
        textAlign: 'center',

        color: '#f26b21',

        fontSize: '8px',

        fontWeight: '800',

        letterSpacing: '1px',

        marginBottom: '5px',
    },


    processTitle: {
        margin:
            '0 0 8px 0',

        textAlign: 'center',

        color: '#26333b',

        fontSize: '13px',

        fontWeight: '800',
    },


    processText: {
        margin: 0,

        textAlign: 'center',

        color: '#7f898f',

        fontSize: '9px',

        lineHeight: '1.6',
    },


    /* =====================================
       CTA
    ====================================== */

    cta: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '1250px',

        margin:
            '0 auto',

        padding:
            '35px 42px',

        boxSizing: 'border-box',

        borderRadius: '22px',

        overflow: 'hidden',

        display: 'flex',

        alignItems: 'center',

        justifyContent: 'space-between',

        gap: '30px',

        background:
            'linear-gradient(135deg, #17232b 0%, #24343e 100%)',

        boxShadow:
            '0 20px 50px rgba(20,30,40,0.13)',
    },


    ctaMobile: {
        flexDirection: 'column',

        alignItems: 'flex-start',

        padding:
            '28px 24px',
    },


    ctaGlow: {
        position: 'absolute',

        width: '350px',
        height: '350px',

        borderRadius: '50%',

        background:
            'rgba(242,107,33,0.15)',

        right: '-160px',
        top: '-170px',

        pointerEvents: 'none',
    },


    ctaContent: {
        position: 'relative',

        zIndex: 2,
    },


    ctaLabel: {
        color: '#f26b21',

        fontSize: '8px',

        fontWeight: '800',

        letterSpacing: '2px',

        marginBottom: '8px',
    },


    ctaHeading: {
        margin: 0,

        color: '#ffffff',

        fontSize:
            'clamp(24px, 3vw, 34px)',

        lineHeight: '1.2',

        fontWeight: '800',

        letterSpacing: '-1px',
    },


    ctaText: {
        maxWidth: '550px',

        margin:
            '10px 0 0 0',

        color:
            'rgba(255,255,255,0.62)',

        fontSize: '11px',

        lineHeight: '1.6',
    },


    ctaButton: {
        position: 'relative',

        zIndex: 2,

        flexShrink: 0,

        border: 'none',

        padding:
            '14px 20px',

        borderRadius: '9px',

        background:
            'linear-gradient(135deg, #f26b21, #ff8c50)',

        color: '#ffffff',

        fontSize: '11px',

        fontWeight: '800',

        cursor: 'pointer',

        display: 'flex',

        alignItems: 'center',

        gap: '13px',

        boxShadow:
            '0 10px 25px rgba(242,107,33,0.25)',
    },


    ctaArrow: {
        fontSize: '17px',

        lineHeight: 1,
    },

};


export default Aboutus;
